import React from "react";
import Routes from "./Routes";

function App() {
  return (
    <>
      {/* Global backdrop for VFX portfolio */}
      <div className="fixed inset-0 -z-10">
        <div className="absolute inset-0 bg-black" />
      </div>

      <div className="relative z-10">
        <Routes />
      </div>
    </>
  );
}

export default App;
